/**
 * Created by neo on 01.09.22.
 */
import { makeAutoObservable } from 'mobx';
import { LocalizedValue, createLocalizedValue } from '../../LocalizedValue';
import { languagePriority } from '../../LocalizedNamedEntity';

export type EarnModelProcessResultJson = {
  ruleId: string;
  ruleIdentifier: string;
  requestId: string;
  processedAt: string;
  pointsCollected: number;
  totalPointsCollected: number;
  rewardLink?: string;
  instantMessage: Partial<LocalizedValue>[];
  ruleName: Partial<LocalizedValue>[];
  estimatedCoinsCollected: number;
  totalEstimatedCoinsCollected: number;
};

export type EarnModelProcessResult = Omit<EarnModelProcessResultJson, 'processedAt' | 'instantMessage' | 'ruleName'> & {
  processedAt: Date;
  instantMessage: LocalizedValue[];
  ruleName: LocalizedValue[];
  readonly defaultRuleName: string;
  getRuleName(lang: string): string;
};

export function createEarnModelProcessResult(json?: Partial<EarnModelProcessResultJson>): EarnModelProcessResult {
  return makeAutoObservable({
    ruleId: json?.ruleId ?? '',
    ruleIdentifier: json?.ruleIdentifier ?? '',
    requestId: json?.requestId ?? '',
    processedAt: json?.processedAt ? new Date(json.processedAt) : new Date(),
    pointsCollected: json?.pointsCollected ?? 0,
    totalPointsCollected: json?.totalPointsCollected ?? 0,
    rewardLink: json?.rewardLink,
    instantMessage: (json?.instantMessage ?? []).map((l) => createLocalizedValue(l)),
    ruleName: (json?.ruleName ?? []).map((l) => createLocalizedValue(l)),
    estimatedCoinsCollected: json?.estimatedCoinsCollected ?? 0,
    totalEstimatedCoinsCollected: json?.totalEstimatedCoinsCollected ?? 0,

    get defaultRuleName(): string {
      for (const lang of languagePriority) {
        const entry = this.ruleName.find((l) => l.lang === lang);
        if (entry) {
          return entry.value ?? '';
        }
      }
      const first = this.ruleName[0];
      return first?.value ?? '';
    },

    getRuleName(lang: string): string {
      return this.ruleName.find((n) => n.lang === lang.toLowerCase())?.value || this.defaultRuleName;
    },
  });
}
